var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lottie',{attrs:{"width":_vm.width,"height":_vm.height,"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}})
}
var staticRenderFns = []

export { render, staticRenderFns }